export const FooterMenus = styled.ul`
    padding-left: 0;
    text-align: center;
    display: inline-block;
    margin-top: 15px;
    margin-bottom: 15px;
`;

export const FooterMenuItem = styled.li`
    display: inline-block;
    text-align: center;
    margin-left: 37px;
    margin-right: 37px;
    margin-bottom: 0;
`;
